module.exports = __webpack_public_path__ + "static/media/bubbles.67fedefc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/biocodex-um/bubbles.png
// module id = 647
// module chunks = 1